var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 42.4 24 3.05 46.8 42.4ZM22.8 30.6h2.85V19.85H22.8Zm1.4 5.3q.65 0 1.15-.5t.5-1.15-.5-1.125-1.15-.475-1.15.5-.5 1.15.5 1.125 1.15.475M8.3 38.35h31.45L24 11.15Z"
})));
export default SvgError;